var _sodipodinamedview, _defs, _sodipodinamedview2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 210 220",
    stroke: "#000000",
    fill: "#000000",
    id: "svg6",
    sodipodidocname: "reject.svg",
    inkscapeversion: "1.1.2 (0a00cf5339, 2022-02-04)",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnssvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodinamedview || (_sodipodinamedview = /*#__PURE__*/React.createElement("sodipodinamedview", {
    id: "namedview6",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0,
    showgrid: "false"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs10"
  })), _sodipodinamedview2 || (_sodipodinamedview2 = /*#__PURE__*/React.createElement("sodipodinamedview", {
    id: "namedview8",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0,
    showgrid: "false",
    inkscapezoom: 3.85,
    inkscapecx: 105.06494,
    inkscapecy: 109.87013,
    "inkscapewindow-width": 1920,
    "inkscapewindow-height": 1019,
    "inkscapewindow-x": 0,
    "inkscapewindow-y": 24,
    "inkscapewindow-maximized": 1,
    "inkscapecurrent-layer": "svg6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 3.1558517,14.164726 H 133.48872 L 108.05124,39.603473 H 28.594592 V 179.51658 H 181.22708 V 101.80375 L 206.66582,76.364998 V 204.95532 H 3.1558517 Z",
    id: "path2",
    style: {
      strokeWidth: 1.27193
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 74.971972,56.817868 29.938868,29.93759 29.93885,-29.93886 0.0356,0.0356 47.82485,-47.8248448 22.80456,22.8032908 -77.76371,77.763696 29.90453,29.90453 -22.80457,22.80456 -29.93886,-29.94013 -29.938858,29.94013 -22.80583,-22.80329 29.94013,-29.94013 -29.94013,-29.938872 z",
    id: "path4",
    style: {
      strokeWidth: 1.27193
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.0fdbfdd094d36f26876a1a916c45c35d.svg";
export { ForwardRef as ReactComponent };